import type { ElementType } from "react";
import ContactMailOutlinedIcon from "@material-ui/icons/ContactMailOutlined";
import BuildOutlinedIcon from "@material-ui/icons/BuildOutlined";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import BundleKey from "../../../../translation/bundleKey";

export type AccessMethodType = "eventual" | "contractor" | "visitor" | "transport" | "employee";

export type AccessMethodOption = {
  type: AccessMethodType;
  labelKey: string;
  icon: ElementType;
};

export const ACCESS_METHOD_OPTIONS: AccessMethodOption[] = [
  {
    type: "eventual",
    labelKey: BundleKey.ACCESS_TYPE_METHOD_EVENTUAL,
    icon: ContactMailOutlinedIcon,
  },
  {
    type: "contractor",
    labelKey: BundleKey.ACCESS_TYPE_METHOD_CONTRACTOR,
    icon: BuildOutlinedIcon,
  },
  {
    type: "visitor",
    labelKey: BundleKey.ACCESS_TYPE_METHOD_VISITOR,
    icon: AutorenewIcon,
  },
  {
    type: "transport",
    labelKey: BundleKey.ACCESS_TYPE_METHOD_TRANSPORT,
    icon: LocalShippingOutlinedIcon,
  },
];
